import "../Css/Main.css";
import intellegnceHome from "../Assets/Images/intellegenceHome.png";
import { Link } from "react-router-dom";

const IntellegnceHome = () => {
  return (
    <div className="bg-night web3-grid-bg pt-10 relative overflow-hidden">
      <div className="glow-orb w-[380px] h-[380px] bg-neonCyan/20 -top-24 -left-24"></div>
      <div className="glow-orb w-[320px] h-[320px] bg-customRed/20 bottom-0 right-0"></div>
      <div className="max-w-[1240px] mx-auto py-20 sm:py-28 lg:py-40 p-4 relative">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-10 place-items-center">
          <div className="order-2 lg:order-1">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-white">
              ARTIFICIAL INTELLIGENCE SERVICES
            </h1>
            <p className="text-base sm:text-lg lg:text-xl text-gray-400 my-4 sm:my-5">
              Let us help you build advanced solutions that elevate your
              business. Our Artificial Intelligence (AI) Development Services
              offer a variety of AI applications, including healthcare
              analytics, virtual assistants, and forecasting tools. Automate
              your business processes with our expert AI development services.
            </p>
            <Link to="/contactUs">
              <button
                type="button"
                className="text-white my-3 bg-customRed neon-btn cursor-pointer focus:outline-none font-bold rounded-full text-md px-5 py-2 hover:scale-110 transition ease-in-out text-center"
              >
                Get free Consultation
              </button>
            </Link>
          </div>
          <div className="order-1 lg:order-2 w-full flex justify-center">
            <img className="w-full max-w-lg h-auto object-contain" src={intellegnceHome} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntellegnceHome;
